import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRushOvercrowded = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1 3C1 1.89543 1.89543 1 3 1C4.10457 1 5 1.89543 5 3C5 4.10457 4.10457 5 3 5C1.89543 5 1 4.10457 1 3ZM2 3C2 2.44772 2.44772 2 3 2C3.55228 2 4 2.44772 4 3C4 3.55228 3.55228 4 3 4C2.44772 4 2 3.55228 2 3Z'
    />
    <path d='M9.00009 3C9.00009 4.10457 8.10458 5 7.00001 5L7.00009 4C7.55237 4 8.00009 3.55228 8.00009 3C8.00009 2.44772 7.55229 2 7.00001 2L7.00009 1C8.10466 1 9.00009 1.89543 9.00009 3Z' />
    <path d='M12.0001 3C12.0001 3.55228 11.5523 4 11 4V5C12.1046 5 13.0001 4.10457 13.0001 3C13.0001 1.89543 12.1046 1 11 1L11.0001 2C11.5524 2 12.0001 2.44772 12.0001 3Z' />
    <path d='M1 8.5C1 7.67157 1.67157 7 2.5 7H3.5C4.32843 7 5 7.67157 5 8.5V10.5C5 10.5814 5.01947 10.6583 5.054 10.7263C5.17758 9.84855 5.50832 9.03737 5.9952 8.34375C5.91454 7.03583 4.82824 6 3.5 6H2.5C1.11929 6 0 7.11929 0 8.5V10.5C0 10.7761 0.223858 11 0.5 11C0.776142 11 1 10.7761 1 10.5V8.5Z' />
    <path d='M4.5 15C4.77614 15 5 14.7761 5 14.5V11H4V14.5C4 14.7761 4.22386 15 4.5 15Z' />
    <path d='M1.5 15C1.77614 15 2 14.7761 2 14.5V11H1V14.5C1 14.7761 1.22386 15 1.5 15Z' />
    <path d='M10.5 12C10.78 12 11 11.78 11 11.5V9H10V11.5C10 11.78 10.22 12 10.5 12Z' />
    <path d='M11.25 13.27C11.25 13.6842 10.9142 14.02 10.5 14.02C10.0858 14.02 9.75 13.6842 9.75 13.27C9.75 12.8558 10.0858 12.52 10.5 12.52C10.9142 12.52 11.25 12.8558 11.25 13.27Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15 11.5C15 13.9853 12.9853 16 10.5 16C8.01472 16 6 13.9853 6 11.5C6 9.01472 8.01472 7 10.5 7C12.9853 7 15 9.01472 15 11.5ZM14 11.5C14 13.433 12.433 15 10.5 15C8.567 15 7 13.433 7 11.5C7 9.567 8.567 8 10.5 8C12.433 8 14 9.567 14 11.5Z'
    />
  </svg>
);
export default SvgRushOvercrowded;
